var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedbin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.7 12C0.7 12.825 1.33 13.5 2.1 13.5H7.7C8.47 13.5 9.1 12.825 9.1 12V3H0.7V12ZM9.8 0.75H7.35L6.65 0H3.15L2.45 0.75H0V2.25H9.8V0.75Z",
    fill: "#FF3333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedbin);
export default __webpack_public_path__ + "static/media/redbin.41c81eeb2524b19b70b31402b7b50dcf.svg";
export { ForwardRef as ReactComponent };